import { defineStore } from "pinia";
import { Classification } from "@/common/models/classification";
import { Group } from "@/common/models/group";
import { fetchGroupClassifications } from "@/common/services/classification.service";
import { useErrorStore } from "@/common/store/error.store";
import { upsertEntities } from "@/common/store/utils";

interface ClassificationsState {
  ids: string[];
  entities: { [id: string]: Classification };
}

export const useClassificationsStore = defineStore("classifications", {
  state: (): ClassificationsState => ({
    ids: [] as string[],
    entities: {} as { [id: string]: Classification },
  }),

  getters: {
    all(state): Classification[] {
      return state.ids.map((id) => this.entities[id]);
    },
  },

  actions: {
    async fetchGroupClassifications(group: Group): Promise<void> {
      try {
        const classifications = await fetchGroupClassifications(group);
        this.fetchGroupClassificationsSuccess(classifications);
      } catch (error) {
        this.fetchGroupClassificationsError(error);
      }
    },

    fetchGroupClassificationsSuccess(classifications: Classification[]): void {
      upsertEntities(classifications, this);
    },

    fetchGroupClassificationsError(err: any): void {
      const errorStore = useErrorStore();
      errorStore.throwError(`fetchGroupClassificationsError: ${err.toString()}`);
    },
  },
});
